<template>
  <div class="clue-page">
    <h1 class="title">
      线索管理
    </h1>

    <div class="setting-bar clearfix">
      <a-button
        v-if="!!cluePremissionData.enableAdd"
        type="primary"
        class="fl"
        @click="addClue"
      >
        录入线索
      </a-button>
      <div class="fr">
        <a-checkbox
          class="fl ml-16"
          :checked="!!istoday"
          @change="handleChange($event)"
        >
          今天需跟进
        </a-checkbox>
        <!-- <a-checkbox
          class="fl ml-16"
          :checked="!!ismy"
          @change="handleChange($event)"
        >
          只看我的
        </a-checkbox> -->
        <div
          v-if="searchConfig"
          class="search-form left fl"
        >
          <a-input-group
            compact
            class="fl"
          >
            <a-select
              v-if="searchConfig.key"
              :value="searchConfig.key"
              @change="handleChangeSearchConfig"
            >
              <a-select-option
                v-for="item in searchConfig.options"
                :key="item.fieldkey"
                :value="item.fieldkey"
              >
                {{ item.fieldname }}
              </a-select-option>
              <i
                slot="suffixIcon"
                class="iconfont iconicon-test19"
              />
            </a-select>
            <a-input
              v-model="searchConfig.value"
              :placeholder="searchConfig.placeholder"
              @change="handleInput"
              @keyup.enter="onSearch"
            >
              <template slot="suffix">
                <i
                  v-if="!isSearch"
                  class="icon iconfont iconicon-test45"
                  @click="onSearch"
                />
                <i
                  v-else
                  class="icon iconfont iconicon-test13-copy"
                  @click="onReset"
                />
              </template>
            </a-input>
          </a-input-group>
        </div>
        <a-select
          v-model="status"
          class="fl ml-16"
          style="width:140px;"
          @change="handleChageStatus"
        >
          <a-select-option
            v-for="item in statusList"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <div
          v-if="!!cluePremissionData.enableExport"
          class="fl ml-16"
        >
          <a-button
            @click.prevent="handleExport"
          >
            导出
          </a-button>
          <!-- 导出配置弹窗 -->
          <export-config
            :visible.sync="showExportConfigModal"
            :data="{page:query.page,limit:query.limit,status,search_type:searchConfig.key,kwd:searchConfig.value, scope}"
          />
        </div>
      </div>
    </div>
    <div class="tab-wrap clue-tabs">
      <a-tabs
        :active-key="scope"
        @change="handleTabs"
      >
        <a-tab-pane
          v-for="item in cluePremissionData.menu"
          :key="item.id"
          :tab="item.name"
        />
      </a-tabs>
    </div>
    <my-table
      ref="clueTable"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import MyTable from './components/Table'
// import ExportBtn from './components/ExportClue'
import ExportConfig from './components/ExportConfig'

export default {
  components: {
    MyTable,
    ExportConfig
  },
  data () {
    return {
      selected: 0,
      status: 0,
      // ismy: 0,
      istoday: 0,
      isChange: false,
      scope: '',
      showExportConfigModal: false,
      scopeList: [
        {
          id: 'all',
          name: '全部线索'
        },
        {
          id: 'myinput',
          name: '我录入的'
        },
        {
          id: 'myfollow',
          name: '我跟进的'
        }
      ]
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('inquery/clue', ['searchConfig', 'loading', 'pagination', 'followLogs', 'cluePremissionData']),
    statusList () {
      return [
        { label: '全部状态', value: 0 },
        { label: '跟进中', value: 1 },
        // { label: '任务超时', value: 3 },
        { label: '转为信息', value: 2 },
        // { label: '无效（无法联系）', value: -2 },
        { label: '无效', value: -1 }
      ]
    },
    isSearch () {
      const { query, searchConfig } = this
      return !!query['search_type'] && !!query.kwd && (!!searchConfig.value && searchConfig.value === query.kwd)
    },
    query () {
      const { query } = this.$route
      return query
    },
    documentTitle () {
      let { projectname = '', comname = '' } = this.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      let title = '线索管理' + projectname + comname
      return title
    }
  },
  watch: {
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    }
  },
  async created () {
    await this.getSearchConfig()
    // await this.fetchClueFieldkeys()
  },
  methods: {
    ...mapMutations('inquery/clue', ['setSearchConfig', 'setIsFollow']),
    ...mapActions('inquery/clue', ['fetchSearchConfig', 'fetchClueDatas', 'finishFollow', 'getCluePermission']),
    async getSearchConfig () {
      const chain2 = await this.getCluePermission()
      chain2.onSuccess(async (raw) => {
        const { menu = [] } = raw
        this.scope = this.query.scope || (menu.length > 0 && menu[0].id)
        const chain = await this.fetchSearchConfig()
        chain
          .onSuccess(async (raw) => {

          })
          .onNetSuccess(async (raw) => {
            const { error, baseinfo } = raw.data
            let { query, scope } = this
            const { system_role: systemRole = 0 } = baseinfo
            query = !(systemRole === 1 || systemRole === 2) ? { ...query } : query
            if (error === 0) {
              this.searchConfig.key = this.query.search_type || (this.searchConfig.options[0] && this.searchConfig.options[0].fieldkey)
              this.searchConfig.value = this.query.kwd || ''
              this.status = query.status * 1 || 0
              // this.ismy = query.ismy * 1
              this.istoday = query.istoday * 1
              await this.setFilterList({ ...query, scope })
            }
          })
          .fetch()
      })
    },

    handleChangeSearchConfig (val) {
      this.clearSearchConfig()
      if (this.searchConfig) {
        this.searchConfig.key = val
      }

      for (let item of this.searchConfig.options) {
        if (item.fieldkey === this.searchConfig.key) {
          this.searchConfig.placeholder = `${this.$t('message["751"]')} ${item.fieldname}`
        }
      }
      this.setSearchConfig(this.searchConfig)
    },
    handleInput () {
      this.setSearchConfig(this.searchConfig)
    },

    async onSearch () {
      const query = {
        ...this.$route.query,
        page: 1,
        'search_type': this.searchConfig.key,
        kwd: encodeURIComponent(this.searchConfig.value)
      }
      await this.setFilterList(query)
      // this.SET_TABLE_SORT({ tableSort: {}, sorter: {} })
    },
    async onReset () {
      this.clearSearchConfig()
      this.$delete(this.query, 'search_type')
      this.$delete(this.query, 'kwd')
      this.$delete(this.query, 'page')
      this.$delete(this.query, 'limit')
      await this.setFilterList(this.query)
    },
    async handleTabs (val) {
      this.scope = val
      const query = {
        ...this.$route.query,
        page: 1,
        'scope': val
      }
      await this.setFilterList(query)
    },
    async setFilterList (args) {
      // const query = { ...this.query }
      this.$delete(args, 'type')
      this.$delete(args, 'from')
      // this.$delete(args, 'page')
      // this.$delete(args, 'limit')
      this.$delete(args, '_t')
      const { page = 1 } = this.$route.query
      // this.pagination.currentPage = args.page ? args.page : page
      await this.fetchClueDatas(args)
      this.$router.push({
        name: 'InqueryClue',
        query: {
          ...args,
          page: args.page ? args.page : page
        }
      })
      // this.pagination.currentPage = args.page ? args.page : page * 1
      // this.ismy = args.ismy * 1
    },
    clearSearchConfig () {
      if (this.searchConfig && this.searchConfig.options) {
        this.searchConfig.value = ''
        this.searchConfig.key = this.searchConfig.options[0] && this.searchConfig.options[0].fieldkey
        this.searchConfig.placeholder = this.searchConfig.options[0] ? `${this.$t('message["754"]')}${this.searchConfig.options[0].fieldname}` : this.$t('message["754"]')
      }
    },
    async handleChange ($event, type) {
      const val = $event.target.checked ? 1 : 0
      // const key = type === 'follow' ? 'istoday' : 'ismy'
      this.$delete(this.query, 'page')
      this.$delete(this.query, 'limit')
      this.istoday = val
      // if (type === 'follow') {
      //   this.istoday = val
      // } else {
      //   this.ismy = val
      // }
      await this.setFilterList({ ...this.query, istoday: val })
    },
    async handleChageStatus (val) {
      this.$delete(this.query, 'page')
      this.$delete(this.query, 'limit')
      await this.setFilterList({ ...this.query, status: val })
      this.status = val
    },
    addClue () {
      this.$router.push({
        name: 'ClueCreate',
        query: {
          type: 'clue'
        }
      })
    },
    // 导出字段
    async handleExport () {
      this.showExportConfigModal = true
      // let page = 1
      // let limit = 200
      // this.percent = 0
      // this.progerssVisible = true
      // await this.requestExportList(page, limit)
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-bar {
  line-height: 32px;
  .left {
    .ant-input {
      width: 240px;
      margin-right: 16px;
      line-height: 32px;
    }
  }
  .search-form ::v-deep {
    .ant-input-group {
      width: auto;
      // margin-right: 16px;
    }
    .ant-select {
      width: 132px;
    }
    .ant-input, .ant-input-affix-wrapper {
      width: 240px;
    }
    .ant-btn {
      margin-right: 16px;
    }

    .ant-select-arrow {
      margin-top: -8px;
    }
    .iconfont {
      color: #ccc;
    }
  }
  .right {

  }
}
.clue-tabs::v-deep{
  padding-top: 8px;
  .ant-tabs-nav-wrap {
    border-top: solid 1px #ebebeb;
  }
  .ant-tabs-bar {
    margin-bottom: 24px;
    border-bottom: 0 none;
  }
  .ant-tabs-nav {
    .ant-tabs-tab {
      margin-right: 16px;
      padding: 8px 2px;
      font-size: 18px;
      font-weight: bold;
      line-height: 32px;
    }
  }
}

</style>
